<template>
    <div>
        <div
            class="card-rank card-rank-top"
        >
            <span
                class="card-rank-bg"          
                :class="[
                    'suit-' + suit,
                    'rank-' + rank
                ]"
            >{{ rank }}</span>
            <span
                class="card-rank-upper"
                :class="[
                    'suit-' + suit,
                    'rank-' + rank
                ]"
            >{{ rank }}</span>
        </div>
        <div
            class="card-rank card-rank-bottom"
        >
            <span
                class="card-rank-bg"
                :class="[
                    'suit-' + suit,
                    'rank-' + rank
                ]"
            >{{ rank }}</span>
            <span
                class="card-rank-upper"
                :class="[
                    'suit-' + suit,
                    'rank-' + rank
                ]"
            >{{ rank }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CardFace',
        props: {
            suit: {
                type: [Number, String],
                required: true
            },
            rank: {
                type: [Number, String],
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/styles/components/_playing-card';
</style>